// Search functions for EntityPicker, built once per module so their identity
// is stable across renders.
import adminApi from '../../services/adminApi';

export const searchReaders = async (query) => {
  const response = await adminApi.getReaders({ search: query, limit: 10 });
  return (response.data.readers || []).map((reader) => ({
    id: reader.id,
    label: reader.name,
    sub: reader.user?.email
  }));
};

export const searchFamilies = async (query) => {
  const response = await adminApi.getFamilies({ search: query, limit: 10 });
  return (response.data.families || []).map((family) => ({
    id: family.id,
    label: family.name,
    sub: `${family.memberCount ?? 0} member(s) · ${family.inviteCode || ''}`
  }));
};

export const searchUsers = async (query) => {
  const response = await adminApi.getUsers({ search: query, limit: 10 });
  return (response.data.users || []).map((user) => ({
    id: user.id,
    label: user.name || user.email,
    sub: user.email
  }));
};

export const searchChurches = async (query) => {
  const response = await adminApi.getChurches({ search: query, limit: 10 });
  return (response.data.churches || []).map((church) => ({
    id: church.id,
    label: church.name,
    sub: church.joinCode
  }));
};
